import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Section from '../components/Section.jsx';
import Tabs from '../components/Tabs.jsx';
import Gallery from '../components/Gallery.jsx';
import milkRates from '../data/milk-rates.json';

const PANCHAYAT = [
  '2 madhayamic (secondary) school',
  '5 middle school',
  '7 primary school',
  '3 up svasthaye kendra',
  '1 police choki (Ravat ka talab)',
  '1 van vibhag choki (Palcha)',
  '3 dam (Modiya Mahadev, Bhadkiya, Gunar)',
  '1 sub station (Palcha)',
  'Road damer lagbhag 75%',
  'Sabhi gaavo ko prayapt bijli mil rahi hai',
];

const WORKERS = [
  {
    caption: 'Vartamaan (present) mai nimnlikhit karmachari hai',
    people: [
      'Bhagvanlal ji Dhaker (retired)',
      'Bholiram ji Dhaker (HM) (Bageria)',
      'Maganlal ji Dhaker (HM) (Bassiguda)',
      'Kanhaya lal ji Dhaker (HM) (Manakpura)',
      'Nand Kishor Dhaker (UPS) (Kochava)',
    ],
  },
  {
    caption: 'Vidyarthi mitra',
    people: [
      'Jagdish Chandra Vaishnav',
      'Ratan Lal Dhaker',
      'Bagdiram Rajapat',
    ],
  },
  {
    caption: 'Other',
    people: ['Hitesh ji Sharma (LDC) (Amarpura)'],
  },
];

const History = () => (
  <div className="prose prose--lead reveal">
    <p>
      About 500 years back a man named Amara put the base of Amarpura village.
      As Amarpura was a small unit of Chittorgarh (Chitragand Morya &rarr;
      Chitracut &rarr; Chittorgarh) rehasat, it was considered in the
      circumference of Chittorgarh rehasat.
    </p>
    <p>
      At that time many types of taxes were taken by the Bijaipur jamindar, who
      came under Chittorgarh rahasat. At present also, people of 52 villages
      that come under Bijaipur rehasat consider Narendra Shing Rav as their
      local king.
    </p>
    <p>
      There are some old shilalekhs still standing &mdash; at the bus stand, and
      near the temple.
    </p>
  </div>
);

const Dairy = () => (
  <div className="stack">
    <div className="prose prose--lead reveal">
      <p>
        Lagbhag 15 sal (year) pahale log apna dugdha bachane Bijaipur jate the.
        San 1988 ke aaspaas Chittorgarh ki Saras dairy se sampark judne ki vajah
        se dono time dugdha bachane ki samsya khatam ho gayi. Logo ko isme fayda
        mahsus hone se unhone pashuu (janvar &mdash; gaay, bheis) ki dekharekha
        achi karne lage. Isi tarah dhire-dhire dugdha ka utpaadan bhi badne
        laga.
      </p>
      <p>
        2011 ke ant (aakhir) mai &lsquo;Rastriya Krishi Vikas Yojana&rsquo; ke
        antargat bulk kular (dugda thanda karne ki mashine) mili, jiski capacity
        2300 liter hai. Vartmaan mai 2000 liter daily dugdha ka sankalan hota
        hai; dugdha datao ko bhi dugdha ki uchit rate milti hai tatha log khush
        hai.
      </p>
    </div>

    <div className="reveal">
      <h3 className="list-caption">Milk rates (&#8377;) by fat and CLR</h3>
      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th scope="col">CLR &darr; / Fat &rarr;</th>
              {milkRates.fat.map((fat) => (
                <th key={fat} scope="col">
                  {fat}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {milkRates.clr.map(({ clr, rates }) => (
              <tr key={clr}>
                <th scope="row">{clr}</th>
                {rates.map((rate, i) => (
                  <td key={`${clr}-${i}`}>{rate}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="table-caption">
        Scroll sideways to see the full fat range.
      </p>
    </div>

    <div className="reveal">
      <h3 className="list-caption">Milk rates (&#8377;) in previous years</h3>
      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th scope="col">Year</th>
              {milkRates.trend.years.map((year) => (
                <th key={year} scope="col">
                  {year}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {milkRates.trend.rows.map(({ animal, rates }) => (
              <tr key={animal}>
                <th scope="row">{animal}</th>
                {rates.map((rate, i) => (
                  <td key={`${animal}-${i}`}>{rate}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

const Administration = () => (
  <div className="stack">
    <div className="prose prose--lead reveal">
      <p>
        Amarpura ek graam panchayat mukhayalay hai jisme 17 gaav aate hai. Graam
        panchayat ki population takriban 3,100 hai. Amarpura panchayat ke
        antargat &mdash;
      </p>
    </div>
    <ul className="facts reveal">
      {PANCHAYAT.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  </div>
);

const Culture = () => (
  <div className="prose prose--lead reveal">
    <p>Yaha par typical (vishiShT) village culture hai.</p>
    <p>
      Mahilae &rarr; gagra, lugda.
      <br />
      Purush &rarr; dhoti, kurta, pagadi.
      <br />
      Nojavan &rarr; jince, toujer &mdash; ie parmparic aur aadhunikata kaa
      mishran.
    </p>
    <p>
      Naata prathaa, bahu vivah, balvivah, martiyubhoj &mdash; choti-moti
      samsyao ka nivaran panchparmeshawar dhawara kiya jata hai.
    </p>
  </div>
);

const Workers = () => (
  <div className="stack">
    {WORKERS.map(({ caption, people }) => (
      <div key={caption} className="reveal">
        <h3 className="list-caption">{caption}</h3>
        <ol className="facts facts--numbered">
          {people.map((person) => (
            <li key={person}>{person}</li>
          ))}
        </ol>
      </div>
    ))}
  </div>
);

const TABS = [
  { id: 'history', label: 'History', render: () => <History /> },
  { id: 'dairy', label: 'Dairy', render: () => <Dairy /> },
  {
    id: 'administration',
    label: 'Administration',
    render: () => <Administration />,
  },
  { id: 'culture', label: 'Culture', render: () => <Culture /> },
  { id: 'workers', label: 'Govt. workers', render: () => <Workers /> },
];

const About = () => (
  <div id="page">
    <Header
      plain
      title="About"
      heading="Five hundred years in the hills."
      kicker="About Amarpura"
      tagline="History, the dairy, the panchayat and the culture of seventeen villages."
    />

    <Section narrow>
      <Tabs items={TABS} label="About Amarpura" />
    </Section>

    <Gallery
      type="about"
      title="The village"
      lead="Fifty photographs of Amarpura and around."
    />
    <Footer />
  </div>
);

export default About;
